/*
 * Copyright (C) 2026 to Present Applause App Quality, Inc. All rights reserved.
 */

import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { UIRouterModule } from '@uirouter/angular';
import { SharedModule } from '../shared/shared.module';
import { CommonComponentsModule } from '../common/components/common-components.module';
import { CommunityModule } from '../common/community/community.module';
import { CommunityFeedModule } from '../common/community/feed/community-feed.module';
import { EmojiHtmlPipe } from '../pipes/emoji-html.pipe';
import { CommunityPageComponent } from './community-page.component';
import { CommunityFeaturedComponent } from './featured/community-featured.component';
import { CommunityFeedComponent } from './feed/community-feed.component';
import { CommunityStatusComposerComponent } from './status-composer/community-status-composer.component';
import { CommunityTrendingComponent } from './trending/community-trending.component';

// The /community page. Not standalone, for the same reason as CommunityFeedModule.
@NgModule({
  imports: [
    CommonModule,
    UIRouterModule,
    SharedModule,
    CommonComponentsModule,
    CommunityModule,
    CommunityFeedModule,
    EmojiHtmlPipe,
  ],
  declarations: [
    CommunityPageComponent,
    CommunityFeaturedComponent,
    CommunityTrendingComponent,
    CommunityFeedComponent,
    CommunityStatusComposerComponent,
  ],
  exports: [CommunityPageComponent],
})
class CommunityPageModule {}

export { CommunityPageModule };
